<template>
    <div class="ApplicationLoader" :aria-label="ariaLabel">
        <div class="circle-loader" :style="styles">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none">
                <path
                    d="M29.125 16C29.125 17.7236 28.7855 19.4303 28.1259 21.0227C27.4663 22.6151 26.4995 24.062 25.2808 25.2808C24.062 26.4995 22.6151 27.4663 21.0227 28.1259C19.4303 28.7855 17.7236 29.125 16 29.125C14.2764 29.125 12.5697 28.7855 10.9773 28.1259C9.38488 27.4663 7.93799 26.4995 6.71922 25.2808C5.50045 24.062 4.53367 22.6151 3.87408 21.0227C3.21449 19.4303 2.875 17.7236 2.875 16C2.875 14.2764 3.21449 12.5697 3.87408 10.9773C4.53368 9.38488 5.50046 7.93799 6.71923 6.71922C7.938 5.50045 9.38489 4.53367 10.9773 3.87408C12.5697 3.21449 14.2764 2.875 16 2.875C17.7236 2.875 19.4303 3.21449 21.0227 3.87408C22.6151 4.53368 24.062 5.50046 25.2808 6.71923C26.4996 7.938 27.4663 9.38489 28.1259 10.9773C28.7855 12.5697 29.125 14.2764 29.125 16L29.125 16Z"
                    :stroke="determinateColor"
                    stroke-width="4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M16 2.875C17.7236 2.875 19.4303 3.21449 21.0227 3.87408C22.6151 4.53367 24.062 5.50046 25.2808 6.71922C26.4995 7.93799 27.4663 9.38488 28.1259 10.9773C28.7855 12.5697 29.125 14.2764 29.125 16"
                    :stroke="indeterminateColor"
                    stroke-width="4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        size: { type: Number, default: 28 },
        determinateColor: { type: String, default: '#E9F4FE' },
        indeterminateColor: { type: String, default: '#2389FD' },
        ariaLabel: { type: String, default: 'GeneralLoadingAllTheThings' }
    },

    computed: {
        styles() {
            return {
                width: `${this.size}px`,
                height: `${this.size}px`,
            };
        },
    },
};
</script>

<style lang="scss" scoped>
@import './styles.module.scss';
</style>
